module.exports = __webpack_public_path__ + "static/img/Risk240826TW.d4f3eda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk240826TW.jpg
// module id = POyS
// module chunks = 1